import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This coastal rooftop was transformed from a barren windswept space into a modern outdoor entertainer complete with floating built in lounge, daybed and bar. The design is simple yet bold using a limited palette of strong colours and materials similar to the contemporary interior of the residence. Striking elements include the timber deck curving up in a wave shape and the apple green colour of the wall behind. Furnishings and plants in the same green or bright white further add to the fresh eye popping composition. Perfect for intimate drinks on a summers evening or partying into the night.',
        ],
        descriptionContent : (
            <p>
            <span className="line">
            <b>Services Undertaken</b>
            <br/>Landscape Architecture
            <br/>Construction
            <br/>Ongoing Maintenance
            </span>
            
            <b>Design Features</b>
            <br/>Contemporary
            <br/>Entertainer
            <br/>Courtyard/Rooftop
            <br/>Seaside
            </p>
        ),
        image : '../images/projects/bondi-5.jpg',
        title : 'Bondi'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/bondi-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/bondi-5.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/bondi-6.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/bondi-2.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/bondi-3.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/bondi-7.jpg'
    },
]

const PageBondi = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageBondi